import React from "react";
import Loader from "../../Loader";
import DateTimePicker from "react-datetime-picker";
import { formStyles } from "../formStyles";

export default function TheftIncidentStep(props) {
  const { register, handleChange, handleSubmit, onSubmit, prevStep, isLoading, states, lgs, police_formations, handleStolenStateChange, stolen_time, setTimeOfStealing, date_reported, setDateReported } = props;

  return (
    <div className={formStyles.card}>
      <h2 className={formStyles.header}>Theft Incident Details</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>Date and Time Stolen</label>
          <div className="border border-gray-300 rounded-lg p-2 bg-white flex items-center h-[50px]">
            <DateTimePicker onChange={setTimeOfStealing} value={stolen_time} className="w-full border-0 focus:ring-0 text-lg" disableClock={true} />
          </div>
        </div>
        <div>
          <label className={formStyles.label}>Mode of Stealing</label>
          <select {...register("mode_of_stealing", { required: true })} className={formStyles.input}>
            <option value="">Select Mode</option>
            <option value="Opportunistic Car Theft">Opportunistic Car Theft (Removed from parked location)</option>
            <option value="Carjacking">Carjacking (Snatched forcefully)</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className={formStyles.label}>State Where Stolen</label>
          <select {...register("state_stolen", { required: true })} onChange={handleStolenStateChange} className={formStyles.input}>
            <option value="">Select State</option>
            {states.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>LGA Where Stolen</label>
          <select {...register("lg_stolen", { required: true })} className={formStyles.input}>
            <option value="">Select LGA</option>
            {lgs.map((val, idx) => <option key={idx} value={val}>{val}</option>)}
          </select>
        </div>
      </div>

      <div className="mb-8">
        <label className={formStyles.label}>Exact Location / Address of Theft</label>
        <input type="text" {...register("stolen_location", { required: true })} className={formStyles.input} placeholder="E.g., In front of Shoprite, Wuse Zone 5" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-slate-50 p-6 rounded-xl border border-gray-200 mb-6">
        <div className="md:col-span-3"><h3 className="font-bold text-slate-800 border-b border-gray-200 pb-2">Police Report Information</h3></div>
        <div>
          <label className={formStyles.label}>Formation Where Reported</label>
          <select {...register("police_formation", { required: true })} onChange={handleChange} className={formStyles.input}>
            <option value="">Select Formation</option>
            {police_formations.map((arr, idx) => <option key={idx} value={arr.name}>{arr.name}</option>)}
          </select>
        </div>
        <div>
          <label className={formStyles.label}>Date Reported</label>
          <div className="border border-gray-300 rounded-lg p-2 bg-white flex items-center h-[50px]">
            <DateTimePicker onChange={setDateReported} value={date_reported || ""} className="w-full border-0 focus:ring-0 text-lg" disableClock={true} />
          </div>
        </div>
        <div>
          <label className={formStyles.label}>Extract Reference Number</label>
          <input type="text" {...register("extract_number", { required: true })} className={`${formStyles.input} uppercase`} />
        </div>
      </div>

      <div>
        <label className={formStyles.label}>Brief Details / Description of Theft</label>
        <textarea maxLength="1000" rows="4" {...register("detailed_description")} onChange={handleChange} className={formStyles.input} placeholder="Provide additional context about the incident..."></textarea>
      </div>

      <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-200">
        <button type="button" onClick={prevStep} className={formStyles.buttonSecondary}>&laquo; Previous</button>
        <button type="button" onClick={handleSubmit(onSubmit)} className={formStyles.buttonPrimary}>
          Save & Next &raquo; {isLoading && <span className="ml-2"><Loader /></span>}
        </button>
      </div>
    </div>
  );
}